import { MasterDialog } from "#common/Dialog/Dialog"
import InputText from "#common/input/InputText"
import { UseContextsCategory } from "#competence/contexts/ContextsCategory"
import { CategoryPost, CategoryPut } from "#competence/services/Api"
import { useApiSend } from "#hooks/useApiSend"
import { Stack } from "@mui/material"
import { useCallback, useEffect, useMemo, useState } from "react"

const dataBase = { name: "", description: "" }

export default function CategoryForm() {
	const { category, refresh, openForm, setOpenForm } = UseContextsCategory()
	const [form, setForm] = useState(dataBase)
	const [disabled, setDisabled] = useState(false)
	const [disabledCancelar, setDisabledCancelar] = useState(false)
	const edit = useMemo(() => !!category?.id, [category?.id])

	useEffect(() => {
		let categoryData = null
		if (category?.id) {
			categoryData = { name: category.name, description: category.description }
		} else categoryData = dataBase
		setForm(categoryData)
	}, [category])

	const success = () => {
		refresh()
		setOpenForm(false)
		setForm(dataBase)
	}
	const end = () => {
		setDisabled(false)
		setDisabledCancelar(false)
	}
	const { fetch: post } = useApiSend(CategoryPost, { success, end })
	const { fetch: put } = useApiSend(CategoryPut, { success, end })

	const fetch = useCallback(
		(data) => {
			if (edit) put(category.id, data)
			else post(data)
		},
		[category, edit, post, put]
	)

	useEffect(() => {
		if (form.name.trim() === "" || form.description.trim() === "") {
			setDisabled(true)
			return
		}
		setDisabled(false)
	}, [form.description, form.name, refresh])

	const buttons = useMemo(() => {
		return [
			{
				label: "Cancelar",
				onClick: () => {
					setForm(dataBase)
					setOpenForm(false)
				},
				disabled: disabledCancelar,
			},
			{
				label: "Guardar",
				onClick: () => {
					setDisabled(true)
					setDisabledCancelar(true)
					fetch(form)
				},
				disabled,
			},
		]
	}, [disabled, disabledCancelar, fetch, form, setOpenForm])

	return (
		<MasterDialog
			{...{
				open: openForm,
				setOpen: setOpenForm,
				title: `${edit ? "Editar" : "Agregar"} Categoría`,
				buttons,
			}}
			maxWidth="sm"
		>
			<Stack spacing={2} sx={{ width: "100%" }}>
				<InputText
					label="Nombre"
					name="name"
					required
					fullWidth
					value={form.name}
					setValue={(data) => setForm({ ...form, name: data })}
				/>
				<InputText
					label="Descripción"
					name="description"
					required
					fullWidth
					multiline={true}
					rows={4}
					value={form.description}
					setValue={(data) => setForm({ ...form, description: data })}
				/>
			</Stack>
		</MasterDialog>
	)
}
